var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, createSlots as _createSlots, renderList as _renderList, createBlock as _createBlock } from "vue";
var _hoisted_1 = { class: "modal__title modal__title--lg" };
var _hoisted_2 = { itemprop: "name" };
var _hoisted_3 = { key: 0 };
var _hoisted_4 = {
    key: 0,
    class: "list__item"
};
var _hoisted_5 = {
    key: 1,
    class: "form-group"
};
var _hoisted_6 = { class: "form-field form-field--text form-field--1 form-field--m form-field--primary" };
var _hoisted_7 = { class: "line line--aic" };
var _hoisted_8 = { class: "line__item" };
var _hoisted_9 = { class: "text text--sm" };
var _hoisted_10 = { class: "line__item line__item--mla" };
var _hoisted_11 = ["disabled"];
var _hoisted_12 = {
    key: 0,
    class: "line__item"
};
var _hoisted_13 = ["disabled"];
var _hoisted_14 = { class: "btn__label" };
var _hoisted_15 = { class: "line__item" };
var _hoisted_16 = ["data-id"];
var _hoisted_17 = { class: "btn__icon" };
var _hoisted_18 = { class: "line__item" };
var _hoisted_19 = ["data-id"];
var _hoisted_20 = { class: "btn__icon" };
var _hoisted_21 = {
    key: 0,
    class: "line__item line__item--mla"
};
var _hoisted_22 = ["disabled"];
var _hoisted_23 = {
    key: 0,
    class: "line__item line__item--mla"
};
var _hoisted_24 = ["href"];
var _hoisted_25 = {
    key: 1,
    class: "line__item"
};
var _hoisted_26 = ["data-id", "disabled"];
var _hoisted_27 = { class: "btn__icon" };
var _hoisted_28 = ["innerHTML"];
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import ModalDialog from "../../components/modal/ModalDialog.vue";
import Sprite from "../../components/Sprite.vue";
import Toast from "../../components/Toast.vue";
import Toasts from "../../components/Toasts.vue";
import UserSetItemsList from "./components/UserSetItemsList.vue";
import EventBus from "../../events/EventBus";
import { hidePreloader, showPreloader } from "../../components/preloader";
import { handleAddToCartButtonClick } from "../../components/product/add_to_cart";
import { useSetsApi } from "./api";
import Message from "../../components/Message.vue";
var DEFAULT_ERROR_MESSAGE = 'Произошла ошибка работы с сетом';
export default /*@__PURE__*/ _defineComponent({
    __name: 'UserSetModal',
    props: {
        set: { type: Object, required: true },
        mode: { type: String, default: 'constructor' },
        authorized: { type: Boolean, default: false },
        status: { type: String, default: 'create' },
        cartProduct: { type: Object, default: null },
        open: { type: Boolean, default: true }
    },
    setup: function (__props, _a) {
        var _b;
        var __expose = _a.expose;
        var props = __props;
        var api = useSetsApi();
        var modal = ref();
        // Аромат, ожидающий выбора позиции для замены
        var pendingOffer = ref(null);
        var saving = ref(false);
        var currentUuid = ref((_b = props.set.uuid) !== null && _b !== void 0 ? _b : null);
        var currentName = ref(props.set.name);
        var lastSavedName = ref(props.set.name);
        var setContent = ref(__spreadArray([], __read(props.set.content), false));
        var isAuthorized = ref(props.authorized);
        var warnings = ref([]);
        var maxItems = computed(function () { return props.set.maxItems; });
        var userAuthorized = computed(function () { return props.authorized || isAuthorized.value; });
        var replacementMode = computed(function () { return !!pendingOffer.value; });
        var canSubmit = computed(function () { return !saving.value && currentName.value.trim().length > 0 && setContent.value.length === maxItems.value; });
        var canBuy = computed(function () { return setContent.value.every(function (item) { return item.available; }); });
        var showPrice = computed(function () { var _a; return !((_a = props.cartProduct) === null || _a === void 0 ? void 0 : _a.url) && props.mode !== 'history'; });
        function applySetData(set) {
            var _a;
            if (set.uuid !== undefined) {
                currentUuid.value = (_a = set.uuid) !== null && _a !== void 0 ? _a : null;
            }
            if (set.name !== undefined) {
                currentName.value = set.name;
                lastSavedName.value = set.name;
            }
            if (set.content) {
                setContent.value = __spreadArray([], __read(set.content), false);
            }
        }
        watch(function () { return props.set; }, applySetData);
        function removeWarning(id) {
            warnings.value = warnings.value.filter(function (w) { return w.id !== id; });
        }
        function showError(message) {
            warnings.value.push({ id: "warning-".concat(Date.now(), "-").concat(Math.random()), text: message });
        }
        /**
         * Выполняет запрос к API сетов: блокирует кнопки на время запроса, рассылает обновлённое состояние сета,
         * при ошибке показывает её текст и вызывает rollback. Возвращает null при ошибке
         */
        function run(request, rollback) {
            return __awaiter(this, void 0, Promise, function () {
                var response, e_1;
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            saving.value = true;
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, 4, 5]);
                            return [4 /*yield*/, request];
                        case 2:
                            response = _b.sent();
                            if (!response.ok) {
                                showError(Object.values((_a = response.error) !== null && _a !== void 0 ? _a : {})[0] || DEFAULT_ERROR_MESSAGE);
                                rollback === null || rollback === void 0 ? void 0 : rollback();
                                return [2 /*return*/, null];
                            }
                            if (response.data) {
                                EventBus.emit('set:update', response.data);
                            }
                            return [2 /*return*/, response];
                        case 3:
                            e_1 = _b.sent();
                            console.error('API Request Error:', e_1);
                            showError(DEFAULT_ERROR_MESSAGE);
                            rollback === null || rollback === void 0 ? void 0 : rollback();
                            return [2 /*return*/, null];
                        case 4:
                            saving.value = false;
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        }
        function show() {
            var _a;
            (_a = modal.value) === null || _a === void 0 ? void 0 : _a.open();
        }
        function close() {
            var _a;
            (_a = modal.value) === null || _a === void 0 ? void 0 : _a.close();
        }
        __expose({ show: show });
        function handleReplacementRequest(offer) {
            if (props.mode !== 'constructor') {
                return;
            }
            pendingOffer.value = { id: offer.id, name: offer.name };
            show();
        }
        function replaceItemByIndex(index) {
            return __awaiter(this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = pendingOffer.value;
                            if (!_a) return [3 /*break*/, 2];
                            return [4 /*yield*/, run(api.replaceItem(index, pendingOffer.value.id))];
                        case 1:
                            _a = (_b.sent());
                            _b.label = 2;
                        case 2:
                            if (_a) {
                                pendingOffer.value = null;
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
        function removeByIndex(index) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, run(api.removeItem(index))];
                        case 1:
                            if ((_a.sent()) && setContent.value.length === 0) {
                                close();
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
        function saveSet() {
            return __awaiter(this, void 0, void 0, function () {
                var ids, response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!canSubmit.value) {
                                return [2 /*return*/];
                            }
                            ids = setContent.value.map(function (item) { return item.offerId; });
                            // После успешного сохранения будет редирект — прелоадер показываем сразу и не скрываем при переходе
                            showPreloader();
                            return [4 /*yield*/, run(api.saveSet(currentName.value.trim(), ids, currentUuid.value))];
                        case 1:
                            response = _a.sent();
                            if ((response === null || response === void 0 ? void 0 : response.ok) && response.redirect) {
                                window.location.href = response.redirect;
                            }
                            else {
                                hidePreloader();
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
        function addToCart() {
            return __awaiter(this, void 0, void 0, function () {
                var type;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!canSubmit.value || !canBuy.value) {
                                return [2 /*return*/];
                            }
                            saving.value = true;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 3, 4]);
                            type = props.mode === 'constructor' ? 'draft' : 'user_set';
                            return [4 /*yield*/, handleAddToCartButtonClick({ type: type, id: currentUuid.value })];
                        case 2:
                            // Черновик после добавления очищается, поэтому окно конструктора закрываем. Сохранённый сет остаётся открытым под окном корзины
                            if ((_a.sent()) && props.mode === 'constructor') {
                                close();
                            }
                            return [3 /*break*/, 4];
                        case 3:
                            saving.value = false;
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        function updateName() {
            return __awaiter(this, void 0, void 0, function () {
                var name;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            name = currentName.value.trim();
                            if (!!name) return [3 /*break*/, 1];
                            currentName.value = lastSavedName.value;
                            return [3 /*break*/, 3];
                        case 1:
                            if (!(name !== lastSavedName.value)) return [3 /*break*/, 3];
                            return [4 /*yield*/, run(api.rename(name), function () { return currentName.value = lastSavedName.value; })];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        function handleExternalUpdate(data) {
            // Событие несёт состояние черновика конструктора — к сохранённому сету оно не относится
            if ((data === null || data === void 0 ? void 0 : data.set) && props.mode === 'constructor') {
                applySetData(data.set);
            }
            if (data.authorized !== undefined) {
                isAuthorized.value = !!data.authorized;
            }
        }
        function handleModalClose(closedModal) {
            if ((closedModal === null || closedModal === void 0 ? void 0 : closedModal.id) === 'user-set-modal') {
                pendingOffer.value = null;
            }
        }
        onMounted(function () {
            EventBus.on('set:update', handleExternalUpdate);
            EventBus.on('set:replacement-requested', handleReplacementRequest);
            EventBus.on('modal:close', handleModalClose);
        });
        onUnmounted(function () {
            EventBus.off('set:update', handleExternalUpdate);
            EventBus.off('set:replacement-requested', handleReplacementRequest);
            EventBus.off('modal:close', handleModalClose);
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(ModalDialog, {
                    id: "user-set-modal",
                    size: "lg",
                    ref_key: "modal",
                    ref: modal,
                    open: __props.open
                }, _createSlots({
                    top: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("span", _hoisted_2, [
                                _cache[1] || (_cache[1] = _createTextVNode("Состав сета", -1 /* CACHED */)),
                                (__props.mode !== 'constructor')
                                    ? (_openBlock(), _createElementBlock("strong", _hoisted_3, " «" + _toDisplayString(currentName.value) + "»", 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ]; }),
                    main: _withCtx(function () { return [
                        _createVNode(UserSetItemsList, {
                            items: setContent.value,
                            mode: __props.mode,
                            showPrice: showPrice.value,
                            replacementMode: replacementMode.value,
                            saving: saving.value,
                            onReplace: replaceItemByIndex,
                            onRemove: removeByIndex
                        }, null, 8 /* PROPS */, ["items", "mode", "showPrice", "replacementMode", "saving"])
                    ]; }),
                    bottom: _withCtx(function () {
                        var _a;
                        return [
                            _createElementVNode("div", _hoisted_7, [
                                (__props.mode === 'constructor')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("div", _hoisted_8, [
                                            _createElementVNode("div", _hoisted_9, "Вы выбрали " + _toDisplayString(setContent.value.length) + " из " + _toDisplayString(maxItems.value) + " ароматов", 1 /* TEXT */)
                                        ]),
                                        _cache[5] || (_cache[5] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_10, [
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "btn btn--1 btn--m btn--black",
                                                onClick: addToCart,
                                                disabled: !canSubmit.value || !canBuy.value || replacementMode.value
                                            }, __spreadArray([], __read((_cache[4] || (_cache[4] = [
                                                _createElementVNode("span", { class: "btn__label" }, "В корзину", -1 /* CACHED */)
                                            ]))), false), 8 /* PROPS */, _hoisted_11)
                                        ]),
                                        _cache[6] || (_cache[6] = _createTextVNode()),
                                        (userAuthorized.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    class: "btn btn--2 btn--m btn--black",
                                                    onClick: saveSet,
                                                    disabled: !canSubmit.value || replacementMode.value
                                                }, [
                                                    _createElementVNode("span", _hoisted_14, _toDisplayString(saving.value ? 'Сохранение...' : 'Сохранить сет'), 1 /* TEXT */)
                                                ], 8 /* PROPS */, _hoisted_13)
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ], 64 /* STABLE_FRAGMENT */))
                                    : _createCommentVNode("v-if", true),
                                _cache[17] || (_cache[17] = _createTextVNode()),
                                (__props.mode === 'profile')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createElementVNode("div", _hoisted_15, [
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "btn btn--2 btn--m btn--black win",
                                                "data-act": "user_set_edit",
                                                "data-id": currentUuid.value
                                            }, [
                                                _createElementVNode("span", _hoisted_17, [
                                                    _createVNode(Sprite, { name: "edit" })
                                                ]),
                                                _cache[7] || (_cache[7] = _createTextVNode()),
                                                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "btn__label" }, "Редактировать", -1 /* CACHED */))
                                            ], 8 /* PROPS */, _hoisted_16)
                                        ]),
                                        _cache[12] || (_cache[12] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_18, [
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "btn btn--2 btn--m btn--gray win",
                                                "data-act": "user_set_delete",
                                                "data-id": currentUuid.value
                                            }, [
                                                _createElementVNode("span", _hoisted_20, [
                                                    _createVNode(Sprite, { name: "remove" })
                                                ]),
                                                _cache[9] || (_cache[9] = _createTextVNode()),
                                                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "btn__label" }, "Удалить", -1 /* CACHED */))
                                            ], 8 /* PROPS */, _hoisted_19)
                                        ]),
                                        _cache[13] || (_cache[13] = _createTextVNode()),
                                        (canBuy.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    class: "btn btn--1 btn--m btn--black",
                                                    onClick: addToCart,
                                                    disabled: !canSubmit.value
                                                }, __spreadArray([], __read((_cache[11] || (_cache[11] = [
                                                    _createElementVNode("span", { class: "btn__label" }, "В корзину", -1 /* CACHED */)
                                                ]))), false), 8 /* PROPS */, _hoisted_22)
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ], 64 /* STABLE_FRAGMENT */))
                                    : _createCommentVNode("v-if", true),
                                _cache[18] || (_cache[18] = _createTextVNode()),
                                (__props.mode === 'cart')
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        ((_a = __props.cartProduct) === null || _a === void 0 ? void 0 : _a.url)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                _createElementVNode("a", {
                                                    href: __props.cartProduct.url,
                                                    class: "btn btn--2 btn--m btn--black"
                                                }, __spreadArray([], __read((_cache[14] || (_cache[14] = [
                                                    _createElementVNode("span", { class: "btn__label" }, "На страницу сета", -1 /* CACHED */)
                                                ]))), false), 8 /* PROPS */, _hoisted_24)
                                            ]))
                                            : (userAuthorized.value)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "btn btn--2 btn--m btn--black win",
                                                        "data-act": "user_set_edit",
                                                        "data-id": currentUuid.value,
                                                        disabled: !canSubmit.value
                                                    }, [
                                                        _createElementVNode("span", _hoisted_27, [
                                                            _createVNode(Sprite, { name: "edit" })
                                                        ]),
                                                        _cache[15] || (_cache[15] = _createTextVNode()),
                                                        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "btn__label" }, "Редактировать", -1 /* CACHED */))
                                                    ], 8 /* PROPS */, _hoisted_26)
                                                ]))
                                                : _createCommentVNode("v-if", true)
                                    ], 64 /* STABLE_FRAGMENT */))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ];
                    }),
                    _: 2 /* DYNAMIC */
                }, [
                    (__props.mode === 'constructor')
                        ? {
                            name: "under_top",
                            fn: _withCtx(function () { return [
                                (pendingOffer.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                        _createVNode(Message, {
                                            gray: "",
                                            icon: "attention-circle"
                                        }, {
                                            default: _withCtx(function () { return [
                                                _createTextVNode("\n          Чтобы добавить «" + _toDisplayString(pendingOffer.value.name) + "», выберите аромат для замены.\n        ", 1 /* TEXT */)
                                            ]; }),
                                            _: 1 /* STABLE */
                                        })
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                        _cache[2] || (_cache[2] = _createElementVNode("label", {
                                            class: "form-label",
                                            for: "set_name"
                                        }, "Название сета", -1 /* CACHED */)),
                                        _cache[3] || (_cache[3] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_6, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                name: "set_name",
                                                class: "form-control",
                                                id: "set_name",
                                                required: "",
                                                placeholder: "Мой сет",
                                                maxlength: "100",
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((currentName).value = $event); }),
                                                onBlur: updateName
                                            }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                                [_vModelText, currentName.value]
                                            ])
                                        ])
                                    ]))
                            ]; }),
                            key: "0"
                        }
                        : undefined
                ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["open"]),
                _cache[22] || (_cache[22] = _createTextVNode()),
                _createVNode(Toasts, { teleport: "#user-set-modal" }, {
                    default: _withCtx(function () { return [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(warnings.value, function (warning) {
                            return (_openBlock(), _createBlock(Toast, {
                                progress: "",
                                "auto-hide": "",
                                icon: "warning",
                                key: warning.id,
                                onClose: function ($event) { return (removeWarning(warning.id)); }
                            }, {
                                default: _withCtx(function () { return [
                                    _createElementVNode("span", {
                                        innerHTML: warning.text
                                    }, null, 8 /* PROPS */, _hoisted_28)
                                ]; }),
                                _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClose"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]; }),
                    _: 1 /* STABLE */
                })
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
